export default {
      id: "icon-emoji-happy-vip-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-emoji-happy-vip",
      toString: function () {
        return this.url;
      }
    }